import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容分类',
    links: [
      { path: '/category/movie', label: '电影' },
      { path: '/category/tv', label: '电视剧' },
      { path: '/category/anime', label: '动漫' },
      { path: '/category/variety', label: '综艺' },
      { path: '/category/documentary', label: '纪录片' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { path: '/about', label: '品牌介绍' },
      { path: '/about', label: '用户口碑' },
      { path: '/about', label: '联系我们' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { path: '/', label: '常见问题' },
      { path: '/', label: '观看指南' },
      { path: '/', label: '反馈建议' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold font-heading text-background-50 whitespace-nowrap">
                yy6080
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              免费高清在线视频平台，海量影视资源（电影、电视剧、动漫、综艺），无需注册，即点即看，畅享极致观影体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="py-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-background-500">
          <p>&copy; {new Date().getFullYear()} yy6080. All Rights Reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}